var map = {
	"./tapcoin/game/fruitRush/1.png": 34337,
	"./tapcoin/game/fruitRush/2.png": 17306,
	"./tapcoin/game/fruitRush/3.png": 74949,
	"./tapcoin/game/fruitRush/4.png": 43352,
	"./tapcoin/game/fruitRush/5.png": 98644,
	"./tapcoin/game/fruitRush/6.png": 4334,
	"./tapcoin/game/fruitRush/7.png": 75172,
	"./tapcoin/game/fruitRush/bg.png": 62762
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63075;